import { render } from "./DashBoard.vue?vue&type=template&id=452d60c4&scoped=true"
import script from "./DashBoard.vue?vue&type=script&lang=js"
export * from "./DashBoard.vue?vue&type=script&lang=js"

import "../css/views/DashBoard.css?vue&type=style&index=0&id=452d60c4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452d60c4"]])

export default __exports__